var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 79,
    viewBox: "0 0 118 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "usersIcon",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11110",
    "data-name": "Path 11110",
    d: "M47.133,15H42.258a21.827,21.827,0,0,0-8.915,1.905A34.06,34.06,0,0,1,47.133,44.25H69.07V36.938A21.938,21.938,0,0,0,47.133,15Z",
    transform: "translate(47.93 21.563)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11111",
    "data-name": "Path 11111",
    d: "M35.732,16.907A21.832,21.832,0,0,0,26.813,15H21.938A21.937,21.937,0,0,0,0,36.938V44.25H21.938A34.06,34.06,0,0,1,35.732,16.907Z",
    transform: "translate(0 21.563)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11112",
    "data-name": "Path 11112",
    d: "M43.688,16H38.813A26.813,26.813,0,0,0,12,42.813V55H70.5V42.813A26.812,26.812,0,0,0,43.687,16Z",
    transform: "translate(17.25 23)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_607",
    "data-name": "Ellipse 607",
    cx: 17.5,
    cy: 17,
    rx: 17.5,
    ry: 17,
    transform: "translate(41)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_608",
    "data-name": "Ellipse 608",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(12 7)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_609",
    "data-name": "Ellipse 609",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(80 7)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/usersIcon.d805d5e767634d276918bb897e0db8bc.svg";
export { ForwardRef as ReactComponent };